import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import 'react-datepicker/dist/react-datepicker.css';
import { isLoggedIn, isVerifyEmail, userToken, logout } from "../../../features/user";
import { setShowUserPopup, showMessage } from "../../../features/common";
import axios from "axios";
import { API_200, API_204, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../../Constants';
import {Trans,  useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage, checkValidToken, userLoggedIn, getLang, navigateTo, showLoading } from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import Input from '../../widgets/Input';

import TextArea from '../../widgets/TextArea';

import Specialization from '../../widgets/Specialization';


export function ProviderRequiredInfo() {
    const [state, setState] = useState({provider:null, errors:{}});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    useEffect(()=>{
        (async () => {
            await checkValidToken(navigate, dispatch, false, true, '/start');
            if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
                getprovider();
            }
        })();
        // eslint-disable-next-line
    },[]);

    const getprovider = async () => {
        showLoading(dispatch, true);
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(`${API_URL }/provider/`, config);
            showLoading(dispatch, false);
            if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_200) {
                if(reply.data.avatar && reply.data.avatar.length === 1) {
                    reply.data.avatar = reply.data.avatar[0];
                }

                setState({
                    ...state,
                    provider: reply.data
                });
            }
        } catch (e) {
            showLoading(dispatch, false);
            dispatch(showMessage({message : errorMessage}));
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validateForm()) {
            showLoading(dispatch, true);
            let errorMessage = DEFAULT_ERROR_TEXT;
            
            let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};
          
            const data = {specialization: state.provider.specialization, yearExperience: state.provider.yearExperience, idCompanyId: state.provider.idCompanyId, mobilePhone: state.provider.mobilePhone, otherPhone: state.provider.otherPhone, summary: state.provider.summary, avatar: state.provider.avatar};

            try {
                const reply = await axios.patch(API_URL + '/provider', data, config);
                showLoading(dispatch, false);
                if(reply.hasOwnProperty('status') && reply.status === API_204) {
                    dispatch(setShowUserPopup({showUserPopup : true}));
                    navigateTo(dispatch, navigate, "/provider");
                    //navigateTo(dispatch, navigate, "-1");
                }
            } catch (e) {
                showLoading(dispatch, false);
                if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                    errorMessage = e.response.data["errors"][0];
                }
                if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate, true)) {
                    dispatch(showMessage({message : errorMessage}));
                }
            }
        } else {
            dispatch(showMessage({message : 'please_fill_input'}));
        }

    };


    const handleNumberChange = (e) => {
        change(e.target.id, e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'));
    };

    const handleChange = (e) => {
        change(e.target.id, e.target.value);
    };

    const change = (id, value) => {
        delete state.errors[id];
        setState({
            ...state, 
            provider:{...state.provider,
                [id]: value,
            },
            errors: {...state.errors},
        });
    };

    const changeList = (listName, id) => {
        let list = state.provider[listName]?? {};
        if(list && list[id]) {
            delete list[id];
        } else {
            list = {...list, [id]: id};
        }
        change(listName, list);
        //return list;
    };

    const changeSpecialization = (id) => {
        changeList('specialization', id);
    };


    const validateForm = () => {
        const errors = {};
        if (!state.provider.specialization || Object.keys(state.provider.specialization).length < 1) {
            errors['specialization'] = 'specialization_error';
        }
        if (!state.provider.yearExperience?.trim()) {
            errors['yearExperience'] = 'year_of_experience_error';
        }
        if (!state.provider.mobilePhone?.trim()) {
            errors['mobilePhone'] = 'mobile_phone_number_error';
        }
        if (!state.provider.summary?.trim()) {
            errors['summary'] = 'provider_summary_error';
        }

        setState({
            ...state,
            errors: errors,
        });

        return Object.keys(errors).length > 0;
    };


    return (
        <Frame showBack={false}>
            <div className='main main-provider-profile'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        {state.provider?<Background showClouds={true} >
                            <div className='right-main-inner'>
                            {/* <form onSubmit={handleSubmit}> */}

                                <div className='mt40'>
                                    <div className='center-div font-19 text-align-center'>{t("to_improve_user_experience")}</div>
                                </div>

                                <Specialization specialization={state.provider.specialization??{}} changeSpecialization={(id) => changeSpecialization(id)} errors={state.errors}></Specialization>

                                <div className='mt40'>
                                    <Input className={state.errors.yearExperience?"error":""} id="yearExperience" placeholder={t("year_of_experience")} value={''+(state.provider.yearExperience??'')} onChange={(e) => handleNumberChange(e)}/>
                                </div>
                                {state.errors.yearExperience && <div className='mt5 error font-12'><Trans i18nKey={state.errors.yearExperience} /></div>}

                                <div className='mt60'>
                                    <Input className={state.errors.idCompanyId?"error":""} id="idCompanyId" placeholder={t("id_company_id")} value={state.provider.idCompanyId??''} onChange={(e) => handleChange(e)}/>
                                </div>

                                <div className='mt10'>
                                    <div className='font-12'>{t("id_field_explanation")}</div>
                                </div>

                                <div className='mt30'>
                                    <Input className={state.errors.mobilePhone?"error":""} id="mobilePhone" placeholder={t("mobile_phone_number")} value={state.provider.mobilePhone??''} onChange={(e) => handleChange(e)}/>
                                </div>
                                {state.errors.mobilePhone && <div className='mt5 error font-12'><Trans i18nKey={state.errors.mobilePhone} /></div>}

                                <div className='mt30'>
                                    <Input className={state.errors.otherPhone?"error":""} id="otherPhone" placeholder={t("another_phone_number")} value={state.provider.otherPhone??''} onChange={(e) => handleChange(e)}/>
                                </div>

                                <div className='mt30'>
                                    <TextArea className={state.errors.summary?"error":""} id="summary" placeholder={t("provider_summary")} footer={t('up_to_200_characters')} value={state.provider.summary??''} onChange={(e) => handleChange(e)}/>
                                </div>
                                {state.errors.summary && <div className='mt5 error font-12'><Trans i18nKey={state.errors.summary} /></div>}

                                <div className='mt10'>
                                    <div className='font-12'>{t("short_info_explanation")}</div>
                                </div>

                                <div className='button-form mt20 mb40' onClick={(e) => handleSubmit(e)}>  <div>{t("edit")}</div> </div>
                            </div>
                            </Background>:null}
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}